import { render, staticRenderFns } from "./NotificacoesApple.vue?vue&type=template&id=43f9bf5c"
import script from "./NotificacoesApple.vue?vue&type=script&lang=ts"
export * from "./NotificacoesApple.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports